import { MANUFACTURING_VENDOR_CURRENCIES } from "../constants";

export const initManufacturingVendor = (vendor = {}) => ({
    ...vendor,

    name: vendor?.name || null,
    site: vendor?.site || null,
    code: vendor?.code || null,

    nation: vendor?.nation || "KOREA",
    currency: vendor?.currency || MANUFACTURING_VENDOR_CURRENCIES.KRW.value,

    isActive: vendor?.isActive || false,
    isForeign: vendor?.isForeign || false,
    isPrimary: vendor?.isPrimary || false,
});

export const initManufacturingVendorDigikey = (vendor = {}) => ({
    ...initManufacturingVendor(vendor),

    credentials: [...(vendor?.credentials || [])].map(initManufacturingVendorDigikeyCredential),
    options: {
        ...(vendor?.options || {}),
        headers: [...(vendor?.options?.headers || [])].map(initManufacturingVendorDigikeyOptionsHeader),
    },
});

export const initManufacturingVendorDigikeyCredential = (credential = {}) => ({
    ...credential,

    client_id: credential?.client_id || null,
    client_secret: credential?.client_secret || null,

    tempId: credential?.tempId || Math.random(),
});

export const initManufacturingVendorDigikeyOptionsHeader = (header = {}) => ({
    ...header,

    key: header?.key || null,
    value: header?.value || null,

    tempId: header?.tempId || Math.random(),
});

export const initManufacturingVendorMouser = (vendor = {}) => ({
    ...initManufacturingVendor(vendor),

    credentials: [...(vendor?.credentials || [])].map(initManufacturingVendorDigikeyCredential),
});

export const initManufacturingVendorMouserCredential = (credential = {}) => ({
    ...credential,

    client_secret: credential?.client_secret || null,

    tempId: credential?.tempId || Math.random(),
});
